// Below this a file is already small enough to upload as it is.
const SMALL_ENOUGH_BYTES = 500 * 1024;

// Shrinks a photo before upload: the longer side to 1600 px, about 80% quality.
// The library keeps the input type, so a transparent PNG stays PNG, and it
// applies the EXIF orientation, so phone photos are not rotated. GIFs are left
// alone, because re-encoding would flatten an animation. If compression fails the
// original is used; the API still enforces its own size limit.
// The library is loaded only when an image needs it. It runs on the main thread:
// its web worker would fetch a second copy of the library from a CDN.
export const compressImage = async (file) => {
    if (file.type === 'image/gif' || file.size <= SMALL_ENOUGH_BYTES) {
        return file;
    }

    try {
        const {default : imageCompression} = await import('browser-image-compression');

        return await imageCompression(file, {
            maxSizeMB        : 1.5,
            maxWidthOrHeight : 1600,
            initialQuality   : 0.8,
            useWebWorker     : false,
        });
    }
    catch (error) {
        console.log(error);
        return file;
    }
};
